import { useEffect } from 'react';
import HeroCarousel from './components/HeroCarousel';
import PlotSummary from './components/PlotSummary';
import LatestEpisodes from './components/LatestEpisodes';
import CastPreview from './components/CastPreview';
import RecommendNav from './components/RecommendNav';

export default function Home() {
  useEffect(() => {
    document.title = '善良的小姨子电视剧剧情介绍与在线观看平台';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        'content',
        '善良的小姨子网站提供电视剧《善良的小姨子》的剧情介绍、演员信息及相关影视资源，方便用户了解故事内容及追剧体验。'
      );
    }
  }, []);

  return (
    <div className="w-full animate-fade-up">
      <HeroCarousel />
      <PlotSummary />
      <LatestEpisodes />
      <CastPreview />
      <RecommendNav />
    </div>
  );
}